import { useState } from "react";
import { RichText } from "../richText";
import { getClassName } from "@pairtreefamily/utils";
import { AdoptionTaxCreditProps } from "./adoptionTaxCredit";
import Button from "../button";

export type FormPayload = {
  name: string;
  value: string;
};

export function Benefits(props: AdoptionTaxCreditProps) {
  const buttonClass = "border-2 py-[12px] px-[40px] rollover-animation";
  const contactInputClass =
    "w-full border-b border-teal text-body-3-medium placeholder:italic focus:outline-0";

  const [formField1, setFormField1] = useState<string>("");
  const [formField2, setFormField2] = useState<string>("");
  const [formField3, setFormField3] = useState<string>("");
  const [formField4, setFormField4] = useState<string>("");

  const [formResponse, setFormResponse] = useState<boolean>(false);

  const formPayload: FormPayload[] = [
    {
      name: "hr_contact_name",
      value: formField1,
    },
    {
      name: "hr_contact_email",
      value: formField2,
    },
    {
      name: "firstname",
      value: formField3.split(" ")[0],
    },
    {
      name: "lastname",
      value: formField3
        .split(" ")
        .splice(1, formField3.split(" ").length - 1)
        .join(" "),
    },
    {
      name: "email",
      value: formField4,
    },
  ];

  const [formIsSubmited, setFormIsSubmited] = useState<boolean>(false);

  const sendContactForm = async () => {
    const hubspotPortalId = "14522431";
    const hubspotFormId = "f9422cf5-90cf-48e3-b505-c3ebb5ce2e2d";
    const endpoint = `https://api.hsforms.com/submissions/v3/integration/submit/${hubspotPortalId}/${hubspotFormId}`;
    const payload = {
      fields: formPayload,
    };

    setFormIsSubmited(true);

    if (
      formPayload.some((field) => field.name !== "lastname" && !field.value)
    ) {
      return;
    }

    const requestOptions: RequestInit = {
      method: "POST",
    };
    requestOptions.body = JSON.stringify(payload);
    requestOptions.headers = { "Content-Type": "application/json" };
    await fetch(endpoint.toString(), requestOptions).then((response) => {
      if (response.ok) {
        setFormResponse(true);
      }
    });
  };
  return (
    <>
      <div className="relative rounded-xl bg-backgroundgray p-8">
        <h2 className="text-deco-head-6">
          {props.moduleInfo.benefits?.heading}
        </h2>
        <h3 className="text-body-3 mb-8 mt-8">
          {props.moduleInfo.benefits?.subHeading}
        </h3>
        {!formResponse && (
          <div>
            <div className="[&>p]:text-body-3 ">
              <RichText content={props.moduleInfo.benefits?.description} />
            </div>

            <form className="mb-8 mt-10 hidden md:block">
              <div className="gap-8 sm:flex">
                <div
                  className={getClassName(
                    "w-full flex-col",
                    formField1 && formField1 !== "" ? "" : "flex",
                  )}
                >
                  {formField1 && formField1 !== "" && (
                    <label className="text-body-4-semi text-black">
                      {props.moduleInfo.benefits?.form?.label1}
                    </label>
                  )}
                </div>
                <div
                  className={getClassName(
                    "mt-8 w-full flex-col sm:mt-0",
                    formField2 && formField2 !== "" ? "" : "flex",
                  )}
                >
                  {formField2 && formField2 !== "" && (
                    <label className="text-body-4-semi text-black">
                      {props.moduleInfo.benefits?.form?.label2}
                    </label>
                  )}
                </div>
              </div>
              <div className="gap-8 sm:flex">
                <div
                  className={getClassName(
                    "w-full flex-col",
                    formField1 && formField1 !== "" ? "" : "flex",
                  )}
                >
                  <input
                    value={formField1}
                    onChange={(e) => setFormField1(e.target.value)}
                    style={{ backgroundColor: "transparent" }}
                    className={contactInputClass}
                    type="text"
                    placeholder={props.moduleInfo.benefits?.form?.label1}
                  />
                </div>
                <div
                  className={getClassName(
                    "mt-8 w-full flex-col sm:mt-0",
                    formField2 && formField2 !== "" ? "" : "flex",
                  )}
                >
                  <input
                    value={formField2}
                    onChange={(e) => setFormField2(e.target.value)}
                    style={{ backgroundColor: "transparent" }}
                    className={contactInputClass}
                    type="text"
                    placeholder={props.moduleInfo.benefits?.form?.label2}
                  />
                </div>
              </div>
              <div className="gap-8 sm:flex">
                <div
                  className={getClassName(
                    "w-full flex-col",
                    formField1 && formField1 !== "" ? "" : "flex",
                  )}
                >
                  {!formField1 && formIsSubmited && (
                    <span className="text-body-13 text-red-600">
                      This field is required
                    </span>
                  )}
                </div>
                <div
                  className={getClassName(
                    "mt-8 w-full flex-col sm:mt-0",
                    formField2 && formField2 !== "" ? "" : "flex",
                  )}
                >
                  {!formField2 && formIsSubmited && (
                    <span className="text-body-13 text-red-600">
                      This field is required
                    </span>
                  )}
                </div>
              </div>
              <div className="mt-8 gap-8 sm:flex">
                <div
                  className={getClassName(
                    "w-full flex-col",
                    formField3 && formField3 !== "" ? "" : "flex",
                  )}
                >
                  {formField3 && formField3 !== "" && (
                    <label className="text-body-4-semi text-black">
                      {props.moduleInfo.benefits?.form?.label3}
                    </label>
                  )}
                </div>
                <div
                  className={getClassName(
                    "mt-8 w-full flex-col sm:mt-0",
                    formField4 && formField4 !== "" ? "" : "flex",
                  )}
                >
                  {formField4 && formField4 !== "" && (
                    <label className="text-body-4-semi text-black">
                      {props.moduleInfo.benefits?.form?.label4}
                    </label>
                  )}
                </div>
              </div>
              <div className="gap-8 sm:flex">
                <div
                  className={getClassName(
                    "w-full flex-col",
                    formField3 && formField3 !== "" ? "" : "flex",
                  )}
                >
                  <input
                    value={formField3}
                    onChange={(e) => setFormField3(e.target.value)}
                    style={{ backgroundColor: "transparent" }}
                    className={contactInputClass}
                    type="text"
                    placeholder={props.moduleInfo.benefits?.form?.label3}
                  />
                </div>
                <div
                  className={getClassName(
                    "mt-8 w-full flex-col sm:mt-0",
                    formField4 && formField4 !== "" ? "" : "flex",
                  )}
                >
                  <input
                    value={formField4}
                    onChange={(e) => setFormField4(e.target.value)}
                    style={{ backgroundColor: "transparent" }}
                    className={contactInputClass}
                    type="text"
                    placeholder={props.moduleInfo.benefits?.form?.label4}
                  />
                </div>
              </div>
              <div className="gap-8 sm:flex">
                <div
                  className={getClassName(
                    "w-full flex-col",
                    formField3 && formField3 !== "" ? "" : "flex",
                  )}
                >
                  {!formField3 && formIsSubmited && (
                    <span className="text-body-13 text-red-600">
                      This field is required
                    </span>
                  )}
                </div>
                <div
                  className={getClassName(
                    "mt-8 w-full flex-col sm:mt-0",
                    formField4 && formField4 !== "" ? "" : "flex",
                  )}
                >
                  {!formField4 && formIsSubmited && (
                    <span className="text-body-13 text-red-600">
                      This field is required
                    </span>
                  )}
                </div>
              </div>
            </form>

            <form className="block md:hidden">
              <div className="gap-8 sm:flex">
                <div
                  className={getClassName(
                    "w-full flex-col",
                    formField1 && formField1 !== "" ? "" : "flex",
                  )}
                >
                  {formField1 && formField1 !== "" && (
                    <label className="text-body-4-semi text-black">
                      {props.moduleInfo.benefits?.form?.label1}
                    </label>
                  )}
                  <input
                    value={formField1}
                    onChange={(e) => setFormField1(e.target.value)}
                    style={{ backgroundColor: "transparent" }}
                    className={contactInputClass}
                    type="text"
                    placeholder={props.moduleInfo.benefits?.form?.label1}
                  />
                  {!formField1 && formIsSubmited && (
                    <span className="text-body-13 text-red-600">
                      This field is required
                    </span>
                  )}
                </div>

                <div
                  className={getClassName(
                    "mt-8 w-full flex-col sm:mt-0",
                    formField2 && formField2 !== "" ? "" : "flex",
                  )}
                >
                  {formField2 && formField2 !== "" && (
                    <label className="text-body-4-semi text-black">
                      {props.moduleInfo.benefits?.form?.label2}
                    </label>
                  )}
                  <input
                    value={formField2}
                    onChange={(e) => setFormField2(e.target.value)}
                    style={{ backgroundColor: "transparent" }}
                    className={contactInputClass}
                    type="text"
                    placeholder={props.moduleInfo.benefits?.form?.label2}
                  />
                  {!formField2 && formIsSubmited && (
                    <span className="text-body-13 text-red-600">
                      This field is required
                    </span>
                  )}
                </div>
              </div>

              <div className="mt-8 gap-8 sm:flex">
                <div
                  className={getClassName(
                    "w-full flex-col",
                    formField3 && formField3 !== "" ? "" : "flex",
                  )}
                >
                  {formField3 && formField3 !== "" && (
                    <label className="text-body-4-semi text-black">
                      {props.moduleInfo.benefits?.form?.label3}
                    </label>
                  )}
                  <input
                    value={formField3}
                    onChange={(e) => setFormField3(e.target.value)}
                    style={{ backgroundColor: "transparent" }}
                    className={contactInputClass}
                    type="text"
                    placeholder={props.moduleInfo.benefits?.form?.label3}
                  />
                  {!formField3 && formIsSubmited && (
                    <span className="text-body-13 text-red-600">
                      This field is required
                    </span>
                  )}
                </div>

                <div
                  className={getClassName(
                    "mt-8 w-full flex-col sm:mt-0",
                    formField4 && formField4 !== "" ? "" : "flex",
                  )}
                >
                  {formField4 && formField4 !== "" && (
                    <label className="text-body-4-semi text-black">
                      {props.moduleInfo.benefits?.form?.label4}
                    </label>
                  )}
                  <input
                    value={formField4}
                    onChange={(e) => setFormField4(e.target.value)}
                    style={{ backgroundColor: "transparent" }}
                    className={contactInputClass}
                    type="text"
                    placeholder={props.moduleInfo.benefits?.form?.label4}
                  />
                  {!formField4 && formIsSubmited && (
                    <span className="text-body-13 text-red-600">
                      This field is required
                    </span>
                  )}
                </div>
              </div>
            </form>

            <RichText content={props.moduleInfo.benefits?.form?.footer} />
            {
              <div>
                <Button
                  color="teal"
                  style="secondary"
                  className={getClassName("mt-8", buttonClass)}
                  onClick={() => sendContactForm()}
                >
                  Send
                </Button>
              </div>
            }
          </div>
        )}
        {formResponse && (
          <div>
            <img className="mt-24" src="/check_gradient.svg" />
            <h3 className="text-head-6 mt-4">
              {props.moduleInfo.benefits?.form?.receivedHeading}
            </h3>
            <p className="text-body-2-medium mt-16">
              {props.moduleInfo.benefits?.form?.receivedDescription}
            </p>
          </div>
        )}

        <img
          className="absolute right-0 top-4"
          src="/graphic_pricing_benefits.svg"
        />
      </div>
    </>
  );
}
